import { useAsync } from 'react-use';
import { useContract } from '@thirdweb-dev/react-core';
import { bigNumberToDecimal } from '@app/helpers/format';

export function useTokenBalance(tokenContractAddress: string, address: string) {
  const { contract } = useContract(tokenContractAddress);

  const { value } = useAsync(async () => {
    if (!contract) {
      return;
    }

    const balance = await contract.call('balanceOf', [address]);
    const decimals = await contract.call('decimals');

    return bigNumberToDecimal(balance, decimals);
  }, [contract, address]);

  return {
    balance: value
  };
}
